<template>
  <div
    :class="$style.container"
    :name="name"
  >
    <label
      v-if="label"
      :class="[
        $style.label,
        $style['label-color'],
        $style['label-font'],
        $style['label-position'],
        $style['label-typography'],
      ]"
    >
      {{ label }}
    </label>
    <SearchBar
      :disabled="disabled"
      :name="name"
      :searchText="searchText"
      :selectedValue="value"
      @blur="handleSearchBarBlur"
      @filterDelete="handleFilterDelete"
      @focus="handleSearchBarFocus"
      @input="handleSearchBarInput"
    />
    <SingleselectDropdown
      :class="$style.singleselect"
      :loading="loadingOptions"
      :open="open && !disabled"
      :options="options"
      :totalOptions="totalOptions"
      :value="value"
      @close="handleClose"
      @input="handleSinglelectInput"
    />
  </div>
</template>

<script>
import SearchBar from 'client/components/SearchWithSingleSelect/SearchBar.vue';
import SingleselectDropdown from 'client/components/SearchWithSingleSelect/SingleselectDropdown.vue';

/**
 * @event {{value: Any, title: String, subtitle: String}} input - value has changed
 * @event {string} filter - filter text has changed
 */
export default {
  name: 'SearchWithSingleSelect',

  components: {
    SingleselectDropdown,
    SearchBar,
  },

  inject: ['$validator'],

  props: {
    disabled: Boolean,
    label: {
      type: String,
      default: '',
    },
    loadingOptions: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      required: true,
    },
    /**
     * @type {{title: String, subtitle: String, value: Any}[]}
     */
    options: {
      type: Array,
      default: () => [],
    },
    searchText: {
      type: String,
      default: '',
    },
    totalOptions: {
      type: Number,
      default: undefined,
    },
    /**
     * @type {{title: String, subtitle: String, value: Any}}
     */
    value: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    open: false,
    searchFocus: false,
  }),

  computed: {
    searchBarText() {
      if (this.open) {
        return this.searchText;
      }
      return '';
    },
  },

  methods: {
    handleClose() {
      this.open = false;
    },
    handleFilterDelete() {
      this.$emit('input', undefined);
    },
    handleSearchBarBlur() {
      this.searchFocus = false;
    },
    handleSearchBarFocus() {
      if (this.disabled) {
        return;
      }

      if (!this.searchFocus && !this.open) {
        this.$emit('filter', '');
      }
      this.searchFocus = true;
      this.open = true;
    },
    handleSearchBarInput(value) {
      this.$emit('filter', value);
    },
    handleSinglelectInput(value) {
      this.$emit('input', value);
      this.searchFocus = false;
      this.open = false;
    },
  },
};
</script>

<style module>
@import "../FormValidation/css/formFields.css";

.container {
  display: block;
}

.singleselect {
  width: 100%;
}
</style>
